export default __webpack_public_path__ + "static/AHJ8MQ9G-c4f44e6b5eb84bb14ef0e4b04c1720a2.jpeg";